import { BaseUrl } from "./AdditionalApi"

export const PostUrlCyber = `${BaseUrl}/api/cyber/`

export default PostUrlCyber